<section class="prazo" aria-labelledby="prazo-titulo">
  <h2 class="prazo-titulo" id="prazo-titulo">Fluxo do Processo - Ouvidoria</h2>
  <p class="prazo-subtitulo">Timeline e prazos da manifestação (protocolo)</p>

  @if (mensagemEnvio(); as mensagem) {
    <p class="prazo-alerta-envio" role="alert">
      <i-lucide name="circle-alert" size="18" aria-hidden="true"></i-lucide>
      {{ mensagem }}
    </p>
  }

  <ol class="prazo-linha">
    @for (etapa of etapas(); track etapa.id) {
      <li class="prazo-etapa" [attr.data-cor]="etapa.cor">
        <span class="prazo-marcador" aria-hidden="true"></span>

        <div class="prazo-cartao" [attr.data-destaque]="etapa.destaque === true">
          <div class="prazo-cabecalho">
            <span class="prazo-ordem">{{ etapa.ordem }}</span>
            <h3 class="prazo-etapa-titulo">{{ etapa.titulo }}</h3>
          </div>

          @if (etapa.linhas?.length) {
            <dl class="prazo-detalhes">
              @for (linha of etapa.linhas; track linha.rotulo) {
                <div class="prazo-detalhe">
                  <dt>{{ linha.rotulo }}</dt>
                  <dd>
                    <strong>{{ linha.valor }}</strong>
                    @if (linha.complemento) {
                      <span class="prazo-detalhe-complemento">{{ linha.complemento }}</span>
                    }
                  </dd>
                </div>
              }
            </dl>
          }

          @if (etapa.selo) {
            <span class="prazo-selo">{{ etapa.selo }}</span>
          }
        </div>
      </li>
    }
  </ol>
</section>
